export default __webpack_public_path__ + "402912d0c25102c74a9922132a4d8e0a.jpg";